<div class="booble-backdrop-drawer-right">
  <div class="drawer-rtl-in">
    <div class="drawer-content-lg">
      <div class="row padding-left-32 drawer-header">
        <div class="col-md-11">
          <div class="d-flex flex-column">
            <h2 class="title-modal">Confirmação do pagamento</h2>
            <p class="p-text-grey-scale-dark mg-bottom-24">
              Confira as informações da ordem para análise de pagamento.
            </p>
          </div>
        </div>

        <div class="col-md-1 d-flex justify-content-end mg-top-10">
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>
      </div>
      <div class="modal-dialog-scrollable-general">
        <div class="modal-body h-100">
          <div class="box-order-value">
            <div>
              <span class="label-order-value"> Valor de destino: </span>
              <span class="order-value"
                >{{ boobleModalData?.currencyDescription }}
                {{ boobleModalData?.amount }}</span
              >
            </div>
            <div>
              <span class="label-order-value">Valor em reais: </span
              ><span class="brl-value">
                {{ this.boobleModalData?.quotations[0]?.amountMN | brl }}</span
              >
            </div>
          </div>
          <div class="radios-motivos">
            <h4 class="mg-left-16 mg-bottom-24">Confirme o valor depositado</h4>

            <div>
              <div>
                <mat-radio-group
                  (ngModelChange)="changeReasonOption()"
                  class="radios-btns mg-left-16"
                  aria-label="Selecione uma opção"
                  [(ngModel)]="reasonApprovePayment"
                >
                  <mat-radio-button value="Pago valor integral">
                    <p class="text-grey-normal">Pago valor integral</p>
                  </mat-radio-button>
                </mat-radio-group>
              </div>

              <mat-radio-group
                (ngModelChange)="changeReasonOption()"
                class="radios-btns mg-left-16"
                aria-label="Selecione uma opção"
                [(ngModel)]="reasonApprovePayment"
              >
                <mat-radio-button value="Valor pago diferente do cotado">
                  <p class="text-grey-normal">Valor pago diferente do cotado</p>
                </mat-radio-button>
              </mat-radio-group>

              <div
                *ngIf="
                  reasonApprovePayment === 'Valor pago diferente do cotado'
                "
                class="col-md-6 mg-left-13"
              >
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>Valor depositado</mat-label>
                  <input
                    matInput
                    [(ngModel)]="valueApprovePayment"
                    (ngModelChange)="onValueChange()"
                    type="text"
                    class=""
                    name=""
                    required
                    currencyMask
                    [options]="{
                      prefix: 'BRL' + ' ',
                      thousands: '.',
                      decimal: ','
                    }"
                  />

                  <mat-error
                    *ngIf="
                      reasonApprovePayment ===
                        'Valor pago diferente do cotado' &&
                      valueApprovePayment == 0
                    "
                    >Valor obrigatório</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
          </div>
          <div
            *ngIf="reasonApprovePayment === 'Valor pago diferente do cotado'"
            class="box-amount-quotation"
          >
            <div>
              <span class="label-amount-quotation">O valor pago é</span>
              <span
                class="amount-quotation"
                [ngClass]="{
                  positive: paymentDifference > 0,
                  negative: paymentDifference < 0
                }"
              >
                {{ differenceSign }}{{ paymentDifference | brl }}
              </span>
              <span class="label-amount-quotation">do valor cotado.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer-new" [style.justify-content]="'space-between'">
        <button
          type="button"
          [style.width]="'134px'"
          class="btn-outline-dark btn"
          (click)="closeModal()"
          type="button"
        >
          Fechar
        </button>
        <button
          type="button"
          class="btn-footer btn btn-dark-primary-blue"
          type="button"
          (click)="approvePayment()"
          [disabled]="validateValueSend()"
        >
          Confirmar
          <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
        </button>
      </div>
    </div>
  </div>
</div>
